import { useIntl } from '@capsicum/common';

export const useWCPledgeDisclaimerModalTexts = () => {
	const { $t } = useIntl();
	const title = $t('worldChampionshipPledge.modals.disclaimer.title');
	const subtitle = $t('worldChampionshipPledge.modals.disclaimer.subtitle');
	const content = $t('worldChampionshipPledge.modals.disclaimer.content');
	const buttonText = $t('worldChampionshipPledge.modals.disclaimer.buttonText');

	return {
		buttonText,
		content,
		subtitle,
		title
	};
};
